import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'QUESTIONBANK_SHOW_ERROR':
      return action.error;

    case 'QUESTIONBANK_SHOW_MERCURE_DELETED':
      return `${action.retrieved['@id']} has been deleted by another user.`;

    case 'QUESTIONBANK_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'QUESTIONBANK_SHOW_LOADING':
      return action.loading;

    case 'QUESTIONBANK_SHOW_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'QUESTIONBANK_SHOW_SUCCESS':
    case 'QUESTIONBANK_SHOW_MERCURE_MESSAGE':
      return action.retrieved;

    case 'QUESTIONBANK_SHOW_RESET':
      return null;
    case 'QUESTIONBANK_QUESTIONBANKVIDEO_SHOW_MERCURE_MESSAGE':
      return {...state, questionBankVideo: action.retrieved};
    default:
      return state;
  }
}

export function eventSource(state = null, action) {
  switch (action.type) {
    case 'QUESTIONBANK_SHOW_MERCURE_OPEN':
      return action.eventSource;

    case 'QUESTIONBANK_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, retrieved, eventSource });
